'use client';

import { ChevronDownIcon, ChevronUpIcon } from '@heroicons/react/24/outline';
import { type ReactElement } from 'react';

import { Button, HeroIcon } from '@/components/atoms';

import { WysiwygCollapsibleProps } from './types';

export const WysiwygCollapsible = ({
  children,
  id,
  expanded,
  onToggle,
  showButton,
  showMoreText,
  showLessText,
  contentRef,
}: WysiwygCollapsibleProps): ReactElement => {
  return (
    <div>
      <div
        ref={contentRef}
        id={id}
        className={`${!expanded ? 'line-clamp-3 md:line-clamp-4 [&_*]:!text-left' : ''}`}
      >
        {children}
      </div>

      {showButton && (
        <Button
          aria-expanded={expanded}
          aria-controls={id}
          size="sm"
          variant="secondary"
          className="mt-4"
          onClick={onToggle}
        >
          <HeroIcon
            className="mr-1"
            icon={expanded ? ChevronUpIcon : ChevronDownIcon}
            size="small"
          />
          {expanded ? showLessText : showMoreText}
        </Button>
      )}
    </div>
  );
};
